import "../styles/projects/project-main.css";
import Button from "react-bootstrap/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGithub } from "@fortawesome/free-brands-svg-icons";
import { faPlayCircle } from "@fortawesome/free-solid-svg-icons";

interface DemoButtonsProps {
  projectData: {
    hasSourceCode: boolean;
    sourceCodeLink?: string;
    hasLiveDemo: boolean;
    liveDemoLink?: string;
  };
}

const DemoButtonsComponent = ({ projectData }: DemoButtonsProps) => {
  return (
    <section className="demo-buttons-section d-flex gap-3 justify-center">
      {projectData.hasSourceCode && (
        <Button
          variant="outline-light" // light outline for contrast on dark blue
          href={projectData.sourceCodeLink}
          target="_blank"
        >
          <FontAwesomeIcon icon={faGithub} className="me-2" />
          See How It’s Built
        </Button>
      )}

      {projectData.hasLiveDemo && (
        <Button
          variant="outline-warning" // warm accent for demo button
          href={projectData.liveDemoLink}
          target="_blank"
        >
          <FontAwesomeIcon icon={faPlayCircle} className="me-2" />
          Launch Site
        </Button>
      )}
    </section>
  );
};

export default DemoButtonsComponent;
